import React, { useContext, useEffect, useState } from "react";
import Layout from 'components/sales/layout/layout';
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";
import { toast } from "react-toastify";

const EditConfig = ({
    history,
    match,
    userdropdown,
    userdropdownlist = [],
    approverdropdown,
    approverdropdownlist = [],
    getAutofillUserData,
    getautofilldatalist = [],
}) => {
    
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [user_id, setUser_Id] = useState(null);
    const [a1_approval_id, setA1_Approval_Id] = useState(null);
    const [a2_approval_id, setA2_Approval_Id] = useState(null);
    const [isModal, setIsModal] = useState(false);
    const [error, setError] = useState(null); // Error state

    const handledropdownValue = (id) => {
        if (id !== '') {
            approverdropdown(id);
        }
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await userdropdown();
            await getAutofillUserData(match.params.id);
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        if(getautofilldatalist?.user_id !== undefined){
            handledropdownValue(getautofilldatalist?.user_id)
            setUser_Id(getautofilldatalist?.user_id)
            setA1_Approval_Id(getautofilldatalist?.first_approval_id)
            setA2_Approval_Id(getautofilldatalist?.second_approval_id)
        }
    }, [getautofilldatalist])

    
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (a1_approval_id === a2_approval_id) {
            // Set an error message
            toast.warning("A1 & A2 approval must be different");
            return;
        }

        const payload = {
            user_id,
            id: match?.params?.id,
            a1_approval_id,
            a2_approval_id,
        };

        setIsLoading(true);
        const url = `${Config.helpdeskUser.updateUserConfig}`;
        try {
            const response = await axios.post(url, payload);
            if (response?.data !== undefined && parseInt(response.data?.status) === 200) {
                setIsModal(true);
            } else {
                setIsModal(true);
                setError(response.data?.message)
            }
        } catch (error) {
            console.error("Error saving data:", error);
        }
        setIsLoading(false);
    };

    const handleModalHide = () => {
        setIsModal(false);
        history.push(`${baseUrl}/helpdesk-listing`);
    };

    return (
        <Layout title={localization.configuration} isLoading={isLoading} isGoback={true}>
            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={handleModalHide}
            >
                {error ? (
                    <div className="error-message">{error}</div>
                ) : (
                    <div className="text-center">
                        <div className="success">
                            <img src={Images?.tick} alt="" />
                        </div>
                        <h5>{localization.updateConfigSuccess}</h5>
                    </div>
                )}
            </ModalPop>
            <form onSubmit={handleSubmit}>
                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{localization.configuration}</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <div className="row">
                                <div className='col-md-6'>
                                    <DropDownInput
                                        data={userdropdownlist}
                                        label={localization.userName}
                                        required
                                        errorMsg={localization.requiredName}
                                        isStarRequired={true}
                                        getIdValue={(value) => {
                                            setUser_Id(value?.id);
                                            handledropdownValue(value?.id);
                                        }}
                                        disabled={true}
                                        getValueById={getautofilldatalist?.user_id}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <DropDownInput
                                        // data={approverdropdownlist}
                                        data={userdropdownlist}
                                        label={localization.firstApproval}
                                        required
                                        errorMsg={localization.requiredName}
                                        isStarRequired={true}
                                        getIdValue={(value) => {
                                            setA1_Approval_Id(value?.id);
                                        }}
                                        getValueById={getautofilldatalist?.first_approval_id}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-6'>
                                    <DropDownInput
                                        // data={approverdropdownlist}
                                        data={userdropdownlist}
                                        label={localization.secondApproval}
                                        required
                                        errorMsg={localization.requiredName}
                                        isStarRequired={true}
                                        getIdValue={(value) => {
                                            setA2_Approval_Id(value?.id);
                                        }}
                                        getValueById={getautofilldatalist?.second_approval_id}
                                    />
                                </div>
                            </div>
                            <div className="btn-wrapper"  style={{marginLeft:'46%', marginBottom:'3%'}}>
                                <button disabled={false} type="submit" className="btn btn-primary">
                                    {localization.submit}
                                    <img src="../images/arrow-right.png" alt="" />
                                </button>
                                <br />
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Layout>
    );
};

export default EditConfig;
